import React from "react";
import { useTranslation } from "react-i18next";
import { FormEntitySelect } from "shared/components/input/select/EntitySelect";
import { TransactionCalculationSelect } from "shared/components/input/select/TransactionCalculationSelect";
import { FormTextInput } from "shared/components/input/text/TextInput";

export const AllocationDetailsFormFields: React.FC<{
  fundFamilyId: string;
  entityId?: string;
  calculationIdsToIgnore?: string[];
}> = ({ fundFamilyId, entityId, calculationIdsToIgnore }) => {
  const { t } = useTranslation(["allocation", "common"]);
  return (
    <>
      <FormTextInput name="name" title={t("common:name")} />
      <TransactionCalculationSelect
        fundFamilyId={fundFamilyId}
        name="transaction_calculation_id"
        calculationIdsToIgnore={calculationIdsToIgnore}
      />
      <FormEntitySelect
        name="entity_id"
        title={t("allocation:details.connectedEntity")}
        fundFamilyId={fundFamilyId}
        isDisabled={!!entityId}
      />
    </>
  );
};
